import React from 'react';
import styled from 'styled-components';
import { Paper, Text, PaperProps } from '@mantine/core';
import { TagsWithDropdown } from '@dealstack/frontend/shared/lib/TagsWithDropdown/TagsWithDropdown.tsx';
import { mapBlockToText } from '@dealstack/shared/lib/format/block.ts';
import { BlockRange } from '@dealstack/shared/lib/generated';

interface Props {
	blocks: BlockRange[];
	unitDenominator?: number;
	color: string;
}

/**
 * Display component for one or more blocks of units showing start and end numbers
 */
export const BlockBox = ({ blocks, color, unitDenominator }: Props) => {
	return (
		<StyledBlockBox withBorder $borderColor={color}>
			<TagsWithDropdown<typeof Text>
				visibleTagCount={1}
				tags={blocks.map((b) => mapBlockToText(b, unitDenominator))}
				offset={13}
				withinPortal
				BadgeElement={Text}
				badgeProps={{
					fz: 'md',
					style: {
						whiteSpace: 'nowrap',
					},
				}}
				targetButtonProps={{
					variant: 'default',
					bg: 'transparent',
					sx: () => ({
						borderColor: color,
						'&:hover': {
							backgroundColor: 'transparent',
						},
					}),
				}}
				menuDropdownProps={{
					w: '100%',
					sx: () => ({
						border: `1px solid ${color}`,
						boxShadow: `0px 16px 32px 0px #DCDFE0`,
					}),
				}}
			/>
		</StyledBlockBox>
	);
};

interface StyledBlockBoxProps {
	$borderColor: string;
	children: React.ReactNode;
	withBorder: boolean;
}

const StyledBlockBox = styled(Paper)<PaperProps & StyledBlockBoxProps>`
	padding: 0.5rem 0.75rem;
	background-color: white;
	z-index: 2;
	border-color: ${(props) => props.$borderColor} !important;
	border-width: 1px;
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;
